import styled from '@emotion/styled';

export const DateHeader5 = styled.h5`
  font-family: Anton;
  font-size: 13px;
  letter-spacing: 1px;
  color: #00c2ba;
  margin-bottom: 6px;
`;
